
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipAlternativeOutlined as ObiOwnShipAlternativeOutlinedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-alternative-outlined.js';
 
 
 

 
 export const ObiOwnShipAlternativeOutlined = createComponent({
   react: React,
   tagName: 'obi-own-ship-alternative-outlined',
   elementClass: ObiOwnShipAlternativeOutlinedElement,
   events: {
     
   }
  });
 
 